import { compactString } from "~/utils/string";

export default compactString;
